import React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { BoxWithTitle } from '../../../../components/common';
import { updateLegalRepresentative, updateAttachedFiles } from '../../../../redux/actions/ReferralActions';
import { getLegalRepresentative } from '../../../../redux/reducers/ReferralReducer';
import StepsFooter from '../steps/StepsFooter';
import { DropFileInput } from '../components/DropFileInput';
import { FullNameInput } from '../components/inputs/FullNameInput';
import { LegalRFCInput } from '../components/inputs/LegalRFCInput';
import { EmailInput } from '../components/inputs/EmailInput';
import { FullAddressInput } from '../components/inputs/FullAddressInput';

const OrderEatLegalRepresentativeStep = (props) => {
  const { t, hasPrevious, handlePrevStep, handleNextStep, lastStep, activeStep, updateLegalRepresentative, legalRepresentative, updateAttachedFiles } = props;

  const handleSubmit = (values, actions) => {
    updateAttachedFiles({
      clientDocument: values.clientDocument,
    });
    delete values.clientDocument;
    updateLegalRepresentative(values);
    handleNextStep();
  };

  const getValidationSchema = () => {
    return Yup.object().shape({
      fullName: Yup.string()
        .required(t('validationRequiredSpanish'))
        .min(2, t('validationMinLengthSpanish', { amount: 2 }))
        .max(40, t('validationMaxLengthSpanish', { amount: 40 })),
      email: Yup.string().email(t('validationEmailSpanish')).required(t('validationRequiredSpanish')),
      rfc: Yup.string()
        .required(t('validationRequiredSpanish'))
        .min(8, t('validationMinLengthSpanish', { amount: 8 }))
        .max(18, t('validationMaxLengthSpanish', { amount: 18 })),
      fullAddress: Yup.string()
        .required(t('validationRequiredSpanish'))
        .min(2, t('validationMinLengthSpanish', { amount: 2 }))
        .max(128, t('validationMaxLengthSpanish', { amount: 128 })),
      clientDocument: Yup.mixed().required(t('validationRequiredSpanish')),
    });
  };

  const footerProps = {
    hasPrevious,
    handlePrevStep,
    lastStep,
    activeStep,
    t,
  };

  const initialValues = {
    fullName: '',
    rfc: '',
    email: '',
    fullAddress: '',
  };

  return (
    <Formik
      onSubmit={(values, actions) => {
        handleSubmit(values, actions);
      }}
      values
      enableReinitialize
      validationSchema={getValidationSchema}
      validateOnChange
      initialValues={legalRepresentative || initialValues}
    >
      {({ errors, touched, values, isSubmitting }) => (
        <Form>
          <BoxWithTitle title={t('labelLegalRepresentativeInformation')}>
            <div className="row">
              <div className="col-lg-6">
                <FullNameInput t={t} errors={errors} touched={touched} />
                <LegalRFCInput t={t} errors={errors} touched={touched} />
              </div>
              <div className="col-lg-6">
                <EmailInput t={t} errors={errors} touched={touched} />
                <FullAddressInput t={t} errors={errors} touched={touched} />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <DropFileInput name="clientDocument" label={t('labelReferralClientDocument')} values={values} />
              </div>
            </div>
          </BoxWithTitle>
          <StepsFooter {...footerProps} isSubmitting={isSubmitting} />
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = (state) => {
  return {
    legalRepresentative: getLegalRepresentative(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateLegalRepresentative,
      updateAttachedFiles,
    },
    dispatch
  );

export default compose(withNamespaces(), connect(mapStateToProps, mapDispatchToProps))(OrderEatLegalRepresentativeStep);
